export default __webpack_public_path__ + "../staticImages/A0001001.png";